/**
 * CTA CLICK PHONE
 * @author alexandre Flatrès
 * par artwaï pour artwaï
 *
 * permet de rendre visible le numéro de téléphone au click sur l'élément sans devoir retoucher au walker
 */
(function () {

    var clickPhone = (window.collections) ? window.collections['clickPhone'] : document.querySelectorAll('a[href^="tel:"]');

    clickPhone.forEach(function (cta) {
        cta.addEventListener('click', function (e) {
            if (!cta.classList.contains('clicked')) {
                e.preventDefault();
                cta.classList.add('clicked');
                let href = cta.getAttribute('href');
                let number = href.split(":")[1];
                let numberArr = number.match(/.{1,2}/g);
                let numberWithSpace = numberArr.join(' ');
                cta.classList.remove('ico-arrow-right');
                cta.querySelector('.text').innerText = numberWithSpace;
            }
        });
    });

}());